import { useEffect, useState } from 'react';

import { permissionsService } from '../../services/permission';
import { useDebounce } from '../../utils/hooks/useDebounce';
import { useFetch } from '../../utils/hooks/useFetch';
import { Header } from './components/Header';
import { Table } from './components/Table';

export const Permissions = (): JSX.Element => {
  const [searchValue, setSearchValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;

  const debouncedSearchValue = useDebounce(searchValue);

  const loadPermissions = (cancelToken: any) =>
    permissionsService.getPaged({
      page: currentPage,
      size: pageSize,
      searchValue: debouncedSearchValue,
      cancelToken
    });

  const [
    {
      data: { results: permissions = [], count: totalItems = 0 },
      isFetching
    },
    getPermissions
  ] = useFetch(loadPermissions);

  useEffect(() => setCurrentPage(1), [debouncedSearchValue]);

  useEffect(() => {
    getPermissions();
  }, [debouncedSearchValue, currentPage, getPermissions]);

  return (
    <div>
      <Header searchValue={searchValue} onSearch={(value: string) => setSearchValue(value)} onAdd={getPermissions} />

      <Table
        currentPage={currentPage}
        pageSize={pageSize}
        onPaginationChange={(page: number) => setCurrentPage(page)}
        permissions={permissions}
        loadingTable={isFetching}
        totalItems={totalItems}
        onChanged={getPermissions}
      />
    </div>
  );
};
